import {APIServices} from "@advthreat/ribbon-components";

export const appConfig = {
  APP: {
    BASE_PATH: process.env.PUBLIC_URL,
    ROUTES: {
      DEFAULT_ROOT: "/",
      INCIDENTS: "/incidents",
      INCIDENT_DETAIL: {
        OVERVIEW: "overview",
        DETECTION: "detection",
        RESPONSE: "response",
        WORKLOG: "worklog"
      },
      INVESTIGATE: "/investigate",
      SAVED_INVESTIGATIONS: "/investigate/saved",
      SAVED: "/saved",
      LOGIN: "/login",
      LOGOUT: "/logout"
    },
    PRIVATE_INTEL_PROXY: {
      ROUTES: {
        BULK_DELETE: "/private-intel/bulk",
        EVENTS: "/events",
        INCIDENT: "/private-intel/incident",
        INCIDENT_SEARCH: "/private-intel/incident/search",
        SUMMARY: "/summary"
      }
    },
    IROH_SERVICES: {
      ROUTES: {
        CODE: "/iroh-auth/code",
        EXECUTE_WORKFLOW: "/iroh/ao/shortcuts/execute-workflow",
        EVENT_SEARCH: "/iroh-event/event/search",
        INSPECT: "/iroh-inspect/inspect",
        LOGIN: "/iroh-auth/login",
        LOGINS: "/iroh-auth/logins",
        NOTE: "/private-intel/note",
        REGISTRY_SETTINGS: "/registry",
        TELEMETRY: "/telemetry/publish",
        USERS_SEARCH: "/user-mgmt/search/users",
        WHOAMI: "/profile/whoami"
      }
    },
    CTIA_SERVICES: {
      ROUTES: {
        BUNDLE_EXPORT_ALL_RELATED_SOURCE_INCIDENTS:
          "/bundle/export?related_to=source_ref&source_type=incident&target_type=incident&include_related_entities=true",
        PLAYBOOK: "/coa/:coa_id/playbook",
        RELATIONSHIP: "/relationship",
        SAVED_INVESTIGATION_SEARCH: "/investigation/search",
        INVESTIGATION: "/investigation",
        CASEBOOK: "/casebook"
      }
    },
    CONURE_SERVICES: {
      EVENTS: "/events",
      INCIDENT: "/incident",
      INVESTIGATION: "/investigation",
      GRAPH: "/graph",
      SAVE: "/save",
      SNAPSHOT: "/snapshot",
      STATUS: "/status",
      SUMMARY: "/summary"
    }
  }
};

export function setLoginOptions(data) {
  if (data && Object.keys(data)) {
    Object.keys(data).forEach((key) => {
      const {me, name, logout} = data[key];
      if (loginOptionLabels[key]) {
        loginOptionLabels[key].me = me;
        loginOptionLabels[key].name = name;
        loginOptionLabels[key].logout = logout;
      } else {
        loginOptionLabels[key] = {me, name, logout};
      }
    });
  }
}

const loginOptionLabels = {
  amp_qa: {
    label: "AMP SDC",
    logoutURL: () => window.CONFIG.ampAccountLogoutUri,
    acctURI: () => window.CONFIG.ampAccountUri
  },
  threatgrid: {
    label: "Threat Grid",
    logoutURL: () => window.CONFIG.threatgridAccountLogoutUri,
    acctURI: () => window.CONFIG.threatgridAccountUri
  },
  amp: {
    label: "Cisco Security",
    logoutURL: () => window.CONFIG.ampAccountLogoutUri,
    acctURI: () => window.CONFIG.ampAccountUri
  },
  "idb-amp": {
    label: "Cisco Security",
    logoutURL: () => window.CONFIG.ampAccountLogoutUri,
    acctURI: () => window.CONFIG.ampAccountUri
  },
  "idb-tg": {
    label: "Threat Grid",
    logoutURL: () => window.CONFIG.threatgridAccountLogoutUri,
    acctURI: () => window.CONFIG.threatgridAccountUri
  },
  "idb-tg-staging": {
    label: "Threat Grid Staging",
    logoutURL: () => window.CONFIG.threatgridAccountLogoutUri,
    acctURI: () => window.CONFIG.threatgridAccountUri
  },
  "idb-amp-staging": {
    label: "AMP SDC Staging",
    logoutURL: () => window.CONFIG.ampAccountLogoutUri,
    acctURI: () => window.CONFIG.ampAccountUri
  },
  sxso: {
    label: "Cisco SecureX Sign-On",
    logoutURL: () => window.CONFIG.sxsoAccountLogoutUri,
    acctURI: () => window.CONFIG.sxsoAccountUri
  }
};

const skipTheseDomains = [
  "cisco.com",
  "sourcefire.com",
  "ctr.com",
  "opendns.com",
  "meraki.net",
  "mymerakilab.net",
  "sfsnort.com",
  "threathuntingworkshop.com"
];

export const skipTheseSubDomainsRegExp = skipTheseDomains.map(
  (d) => new RegExp(`${d}$`)
);

export function configureRibbon() {
  APIServices.host = window.CONFIG.apiBaseUri;
  APIServices.apiHost = window.CONFIG.apiBaseUri;
  APIServices.integration = {name: "xdr-ui", region: window.CONFIG.environment};
}
